class TechnologyHotspots extends HTMLElement {

  constructor() {
    super()
  }

  connectedCallback() {
    this.initSlider()
    this.bindHotspots()
    this.updateActiveDot(0)
    this.bindNavigation()
    this.updateNavigation()
    this.querySelector('.tech-modal-close')?.addEventListener('click', () => this.closeModal())
    this.querySelector('.tech-modal-overlay')?.addEventListener('click', () => this.closeModal())
  }

  initSlider() {

    this.slider = new Swiper(this.querySelector('.tech-hotspots__slides .swiper'), {
      slidesPerView: "auto",
      spaceBetween: 40,
      speed: 500,
      observer: true,
      observeParents: true,
      autoHeight: false,
    })

    // slide change → active dot
    this.slider.on('slideChange', () => {

      const index = this.slider.activeIndex
      this.updateActiveDot(index)
      this.updateNavigation()
    })

  }

  bindHotspots(){

    const dots = this.querySelectorAll('.tech-hotspot')

    dots.forEach(dot => {

      dot.addEventListener('click', () => {

        const index = Number(dot.dataset.index)

        if(window.innerWidth <= 989){

          this.openModal(index)

        } else {

          this.slider.slideTo(index)

        }

      })

    })

  }

  updateActiveDot(index){

    const dots = this.querySelectorAll('.tech-hotspot')

    dots.forEach(dot => dot.classList.remove('active'))

    if(dots[index]){
      dots[index].classList.add('active')
    }

  }

  bindNavigation(){

    this.querySelectorAll('.tech-slider-next').forEach(btn => {
      btn.addEventListener('click', () => {
        this.slider.slideNext()
      })
    })

    this.querySelectorAll('.tech-slider-prev').forEach(btn => {
      btn.addEventListener('click', () => {
        this.slider.slidePrev()
      })
    })

  }

  updateNavigation(){

    const isStart = this.slider.isBeginning
    const isEnd = this.slider.isEnd

    this.querySelectorAll('.tech-slider-prev').forEach(btn => {
      btn.disabled = isStart
    })

    this.querySelectorAll('.tech-slider-next').forEach(btn => {
      btn.disabled = isEnd
    })

  }

  openModal(index){

    const modal = this.querySelector('.tech-hotspots-modal')

    modal.classList.add('active')

    document.body.classList.add('modal-open')

    this.slider.update()

    this.slider.slideTo(index, 0)

  }

  closeModal(){

    this.querySelector('.tech-hotspots-modal').classList.remove('active')

    document.body.classList.remove('modal-open')

  }

}



if (!customElements.get('technology-hotspots')) {
  customElements.define('technology-hotspots', TechnologyHotspots)
}